export default __webpack_public_path__ + "static/media/fr.2b73cc5a.svg";